import React from "react";
import AssetForm from "./components/AssetForm";

function App() {
  return <AssetForm />;
}

export default App;
